import React, { useState, useEffect } from "react";

const MemberDetails = ({
  id_R,
  id,
  closeMemberDetails,
  isMemberDetailsOpen,
  firstName,
  lastName,
  gender,
  middleName,
  dob,
  identification,
  setFirstName,
  setLastName,
  setMiddleName,
  setIdentification,
  setGender,
  setDob,
  setIsIDModalOpen,
  handleNextButtonClick,
}) => {
  const [isInputsFilled, setIsInputsFilled] = useState(false);

  const handleBackButtonClick = () => {
    setFirstName("");
    setLastName("");
    setMiddleName("");
    setIdentification("");
    setGender("");
    setDob("");
    setIsIDModalOpen(true);
    closeMemberDetails();
  };

  useEffect(() => {
    const areInputsFilled = !!(firstName && lastName && middleName);
    setIsInputsFilled(areInputsFilled);
  }, [firstName, lastName, middleName]);

  return (
    <>
      <div
        id={id_R}
        className={`${
          isMemberDetailsOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex fixed min-h-[80%] w-[62%]">
          <div className="relative flex bg-white shadow w-full mx-auto">
            <div className="w-full flex flex-col mx-5">
              <div className="flex items-center justify-end">
                <button
                  onClick={closeMemberDetails}
                  type="button"
                  className="bg-transparent  rounded-lg text-sm p-1.5 ml-auto inline-flex items-center "
                  data-modal-toggle={id_R}
                >
                  <svg
                    width="61"
                    height="43"
                    viewBox="0 0 61 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_13891_3896)">
                      <path
                        d="M32.84 28L30.7 24.9L28.9 28H25.2L28.88 22.3L25.1 16.84H28.94L31.08 19.92L32.88 16.84H36.58L32.84 22.46L36.68 28H32.84Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_13891_3896">
                        <rect width="61" height="43" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              <div>
                <div className="mt-6 mx-auto items-center">
                  <p className="text-[#000] text-xl font-bold">
                    Review Members’ details
                  </p>
                  <div className="text-[#000] mt-4 text-sm font-normal">
                    <p>
                      Please upload identity documents to verify the member's
                      identity and personal details. Ensure that the provided
                      identity document clearly matches the member's face.
                    </p>
                  </div>
                </div>
                <div className=" w-[100%]">
                  <div className="flex justify-between w-full mt-10 mr-4">
                    <div className="flex w-[50%] flex-col justify-center">
                      <label
                        htmlFor="identification"
                        className="mb-1 text-md font-medium text-[#000]"
                      >
                        Identity document Number
                      </label>
                      <input
                        id="identification"
                        type="text"
                        value={identification}
                        onChange={(e) => setIdentification(e.target.value)}
                        className="flex items-center text-[#000000] rounded-[4px] px-3 w-[94%] h-10 bg-[#EAEAEA] text-[16px] font-[300]"
                      />
                    </div>
                    <div className="flex w-[50%] flex-col justify-center">
                      <label
                        htmlFor="firstName"
                        className="mb-1 text-md font-medium text-[#000]"
                      >
                        First name
                      </label>
                      <input
                        id="firstName"
                        type="text"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        className="flex items-center text-[#000000] rounded-[4px] px-3 w-[94%] h-10 bg-[#EAEAEA] text-[16px] font-[300]"
                      />
                    </div>
                  </div>
                  <div className="flex w-full justify-between mt-10 mr-4">
                    <div className="flex w-[50%] flex-col justify-center">
                      <label
                        htmlFor="middleName"
                        className="mb-1 text-md font-medium text-[#000]"
                      >
                        Middle name
                      </label>
                      <input
                        id="middleName"
                        type="text"
                        value={middleName}
                        onChange={(e) => setMiddleName(e.target.value)}
                        className="flex items-center text-[#000000] rounded-[4px] px-3 w-[94%] h-10 bg-[#EAEAEA] text-[16px] font-[300]"
                      />
                    </div>
                    <div className="flex w-[50%] flex-col justify-center">
                      <label
                        htmlFor="lastName"
                        className="mb-1 text-md font-medium text-[#000]"
                      >
                        Last name
                      </label>
                      <input
                        id="lastName"
                        type="text"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        className="flex items-center text-[#000000] rounded-[4px] px-3 w-[94%] h-10 bg-[#EAEAEA] text-[16px] font-[300]"
                      />
                    </div>
                  </div>
                  <div className="flex w-full justify-between mt-[50px] mr-4">
                    <div className="flex w-[50%] flex-col justify-center">
                      <label
                        htmlFor="dob"
                        className="mb-1 text-md font-normal text-[#000]"
                      >
                        Date of Birth
                      </label>
                      <input
                        id="dob"
                        type="date"
                        value={dob}
                        onChange={(e) => setDob(e.target.value)}
                        className="w-[95%] h-10 px-4 rounded-[4px] border border-[1px] bg-[#EAEAEA] border-[#000]"
                      />
                    </div>
                    <div className="flex w-[50%] flex-col justify-center">
                      <label
                        htmlFor="gender"
                        className="mb-1 text-md font-medium text-[#000]"
                      >
                        Gender
                      </label>
                      <select
                        id="gender"
                        value={gender || ""}
                        onChange={(e) => setGender(e.target.value)}
                        className="flex items-center text-[#000000] rounded-[4px] px-3 w-[94%] h-10 bg-[#EAEAEA] text-[16px] font-[300]"
                      >
                        <option value="" disabled>
                          Choose gender
                        </option>
                        <option value={gender}>{gender}</option>
                        {["MALE", "FEMALE"]
                          .filter((g) => g !== gender)
                          .map((g) => (
                            <option key={g} value={g}>
                              {g.charAt(0).toUpperCase() + g.slice(1)}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="w-[97%] mt-20 mb-12 flex justify-between mr-20">
                    <button
                      onClick={handleBackButtonClick}
                      data-modal-toggle={id_R}
                      type="button"
                      className="text-[#ffff] bg-[#FF5757] hover:bg-[#FF5757] focus:outline-none font-medium rounded-[5px] text-sm px-7 py-2.5 text-center"
                    >
                      Back, this doesn’t look right repeat
                    </button>
                    <button
                      className={`${
                        isInputsFilled
                          ? "bg-[#074073] hover:bg-[#074073] focus:outline-none"
                          : "bg-[#D9D9D9] pointer-events-none"
                      } block  font-medium rounded-[5px] text-[#ffff] text-sm px-8 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800,`}
                      disabled={!isInputsFilled}
                      onClick={handleNextButtonClick}
                    >
                      Continue, this looks right, proceed
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MemberDetails;
